import styles from './styles.module.scss';
import cn from 'classnames';
import { InlineSvg } from 'components/svg';
import { FC, PropsWithChildren, useState } from 'react';

interface CollapsibleProps {
  title: string;
  defaultExpanded?: boolean;
  className?: string;
}

export const Collapsible: FC<PropsWithChildren<CollapsibleProps>> = ({
  title,
  defaultExpanded = false,
  className,
  children
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className={className}>
      <div
        className="d-flex align-items-center justify-content-between cursor-pointer py-2"
        onClick={() => setExpanded((prev) => !prev)}
        aria-expanded={expanded}
      >
        <span className="fw-bold text-dark">{title}</span>
        <div className={cn('cursor-pointer', styles.chevron, { [styles.expanded]: expanded })}>
          <InlineSvg path="/media/workshop-log/collapsible.svg" className="svg-icon-2" svgClassName="text-primary" />
        </div>
      </div>
      {expanded && children}
    </div>
  );
};
